export const homePageInitialConfigs: any = {
  FREE_FORM_INPUT: {
    customTitle: {
      en: '',
      fr: '',
    },
    showInCard: true,
    useCodeEditor: false,
    disableQuill: false,
    template: {
      en: '',
      fr: '',
    },
    allowFullScreen: false,
  },
};
